<template>
  <v-dialog
    v-if="Object.keys(systemInformation).length"
    transition="dialog-bottom-transition"
    persistent
    v-model="dialog"
    width="450"
  >
    <v-card class="pt-4">
      <v-card-text>
        <v-chip
          :color="translateCategoryJa(systemInformation.category).color"
          label
          small
        >
          {{ translateCategoryJa(systemInformation.category).label }}
        </v-chip>
        <span style="float: right">
          {{ systemInformation.notificationStartAt | momentDateTime }}
        </span>
        <p class="mt-3" style="font-size: 20px; color: black">
          {{ systemInformation.title }}
        </p>
        <p class="mt-2">{{ systemInformation.content }}</p>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="mt-2"
            color="green"
            dark
            tile
            small
            @click="comfirmSystemInformation(systemInformation)"
          >
            確認
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { deserialize } from 'deserialize-json-api'
import Qs from 'qs'
import formatUtils from '@/mixins/format_utils'
import api from '@/plugins/api'
import systemInformationUtils from '@/mixins/system_information_utils'

export default {
  name: 'SystemInformationConfirmDialog',
  mixins: [formatUtils, systemInformationUtils],
  data () {
    return {
      dialog: false,
      systemInformations: [],
      systemInformation: {}
    }
  },
  async mounted () {
    let { data } = await api.fetchSystemInformations({
      params: {
        q: {
          status_eq: 1
        },
        order_with: 'notification_start_at_asc'
      },
      paramsSerializer: function (params) {
        return Qs.stringify(params, { arrayFormat: 'brackets' })
      }
    })
    this.systemInformations = deserialize(data).data
    this.setSystemInformaiton()
  },
  methods: {
    comfirmSystemInformation (information) {
      api.readSystemInformation(information.id)
      this.dialog = false
      this.readSystemInformation(information)
    },
    setSystemInformaiton () {
      this.systemInformation = this.systemInformations.find(
        (data) => data.read === false
      )
      if (this.systemInformation) {
        this.dialog = true
      } else {
        this.systemInformation = {}
      }
    },
    readSystemInformation (systemInformation) {
      this.systemInformations.map((element) => {
        if (element.id !== systemInformation.id) {
          return
        }
        element.read = true
      })
      this.setSystemInformaiton()
    }
  }
}
</script>
